import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import firebase from "@/configs/firebase-setup";
const Blogfeed = () => import("@/views/blog/blogfeed.vue");
const Blogpost = () => import("@/views/blog/post.vue");

const GamesFeed = () => import("@/views/games/feed.vue");
const StarchaserDetails = () => import("@/views/games/starchaser-details.vue");

const PostsList = () => import("@/views/admin/posts-list.vue");
const EditPost = () => import("@/views/admin/edit-post.vue");
const CreatePost = () => import("@/views/admin/create-post.vue");
const LoginAdmin = () => import("@/views/admin/login.vue");

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
    {
      path: "/devlog/feed",
      name: "Devlog",
      component: Blogfeed,
    },
    {
      path: "/devlog/post/:postId",
      props: true,
      name: "DevlogDetails",
      component: Blogpost,
    },
    {
      path: "/games",
      name: "GamesFeed",
      component: GamesFeed,
    },
    {
      path: "/games/starchaser",
      name: "GameDetailsStarChaser",
      component: StarchaserDetails,
    },
    {
      path: "/admin",
      name: "PostsList",
      meta: { requiresAuth: true },
      component: PostsList,
    },
    {
      path: "/admin/create-post",
      name: "CreatePost",
      meta: { requiresAuth: true },
      component: CreatePost,
    },
    {
      path: "/admin/:id/edit",
      props: true,
      name: "EditPost",
      meta: { requiresAuth: true },
      component: EditPost,
    },
    {
      path: "/admin/login",
      name: "LoginAdmin",
      component: LoginAdmin,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && firebase.auth().currentUser == null) {
    next({ name: "LoginAdmin" });
  } else {
    next();
  }
});

export default router;
